<style lang="scss" scoped>
.icon {
  margin-left: -4px;
  color: rgb(191, 203, 217);
}
</style>

<template>
  <el-submenu :index="item.pathName || item.name" :key="item.pathName" v-if="item.children && item.children.length">
    <template slot="title">
      <i v-if="root" :class="item.icon + ' icon'"></i>
      <span>{{ item.name }}</span>
    </template>
    <menu-item v-for="child of item.children" :item="child" :key="child.pathName" />
  </el-submenu>
  <el-menu-item :index="item.pathName || item.name" :key="item.pathName" v-else>
    <i v-if="root" :class="item.icon + ' icon'"></i>
    <span slot="title">{{ item.name }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    item: {
      default() {
        return [];
      }
    },
    root: {
      default: false
    }
  }
};
</script>
